import palette from "assets/theme/base/palette";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const NoContent = ({
  title,
  subtitle,
  icon = "inbox",
  iconColor = palette.brand[500],
  iconBg,
}) => {
  const { t } = useTranslation();
  const bg = iconBg || `${iconColor}18`;
  const supportEmail = "support@maxu.co";

  const mailtoHref = `mailto:${supportEmail}?subject=${encodeURIComponent(
    t("support.subject", { email: supportEmail })
  )}&body=${encodeURIComponent(t("support.body"))}`;

  return (
    <Card
      sx={{
        mt: 3,
        borderRadius: "20px",
        border: `1px solid ${palette.neutral[200]}`,
        boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        overflow: "hidden",
      }}
    >
      <MDBox display="flex" alignItems="center" gap={4} p={4} flexWrap="wrap">
        {/* ── Illustration ── */}
        <MDBox
          sx={{
            flexShrink: 0,
            width: 140,
            height: 140,
            borderRadius: "50%",
            bgcolor: bg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {/* Decorative sparkles */}
          <MDBox sx={{ position: "absolute", top: 6,  left: 12,  color: palette.brand[300],  fontSize: "14px", lineHeight: 1 }}>✦</MDBox>
          <MDBox sx={{ position: "absolute", top: 18, right: 8,  color: "#f48326",            fontSize: "10px", lineHeight: 1 }}>✦</MDBox>
          <MDBox sx={{ position: "absolute", bottom: 10, left: 10, color: "#9c27b0",          fontSize: "8px",  lineHeight: 1 }}>●</MDBox>
          <MDBox sx={{ position: "absolute", bottom: 16, right: 14, color: palette.brand[400], fontSize: "8px", lineHeight: 1 }}>●</MDBox>

          <MDBox
            sx={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              bgcolor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: `0 4px 16px ${bg}`,
            }}
          >
            <Icon sx={{ fontSize: "44px !important", color: iconColor }}>{icon}</Icon>
          </MDBox>
        </MDBox>

        {/* ── Content ── */}
        <MDBox flex={1} minWidth={200}>
          <MDTypography variant="h5" fontWeight="bold" sx={{ color: "text.primary", mb: 0.75 }}>
            {title}
          </MDTypography>
          {subtitle && (
            <MDTypography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7, mb: 2 }}>
              {subtitle}
            </MDTypography>
          )}

          <Divider sx={{ mb: 2 }} />

          {/* Support row */}
          <MDBox display="flex" alignItems="center" justifyContent="space-between" gap={2} flexWrap="wrap">
            <MDBox display="flex" alignItems="flex-start" gap={1.5}>
              <MDBox
                sx={{
                  width: 40, height: 40, borderRadius: "50%", flexShrink: 0,
                  bgcolor: `${palette.brand[500]}14`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}
              >
                <Icon sx={{ color: palette.brand[500], fontSize: "20px !important" }}>headset_mic</Icon>
              </MDBox>
              <MDTypography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                {t("noContent.contactSupportPrefix")}<br />
                {t("noContent.contactSupportSuffix")}{" "}
                <MDBox
                  component="a"
                  href={`mailto:${supportEmail}`}
                  sx={{ color: palette.brand[500], fontWeight: 700, textDecoration: "none" }}
                >
                  {supportEmail}
                </MDBox>
                .
              </MDTypography>
            </MDBox>

            <MDButton
              component="a"
              href={mailtoHref}
              variant="outlined"
              startIcon={<Icon>email</Icon>}
              sx={{
                borderRadius: "12px", px: 2.5, py: 1,
                fontWeight: 600, textTransform: "none",
                borderColor: palette.brand[400], color: palette.brand[500],
                "&:hover": { bgcolor: palette.brand[50] },
                whiteSpace: "nowrap",
              }}
            >
              {t("noContent.contactSupportButton")}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default NoContent;
